import { useCallback } from "preact/hooks";
import useBotRequest from "@/components/chatbots/twitch/data/useBotRequest.js";

export function useGetWebhooks({
  twitchUsername,
  twitchAccessToken,
  twitchTokenValidated,
  twitchBroadcasterID,
}) {
  const handleBotRequest = useBotRequest({
    twitchUsername,
    twitchAccessToken,
    twitchBroadcasterID,
  });

  return useCallback(async () => {
    const url = `${import.meta.env.VITE_TWITCH_URI}/webhooks/twitch/manage/get`;

    if (!twitchAccessToken || !twitchTokenValidated) {
      return { success: false, webhooks: null };
    }

    const { data: webhooks, success } = await handleBotRequest(url);

    return { success, webhooks };
  }, [handleBotRequest, twitchAccessToken, twitchTokenValidated]);
}
